import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  postSic, fetchVerificarStatusCidade, fetchConfiguracoes, fetchSecretarias, fetchOrientacoes, fetchUrgenteJustificativas, fetchSecretarias2,
} from '../../api/endpoints';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { desfazerSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import { desfazerCidade, selectCidade } from '../../app/slices/cidadesSlice';
import {
  Alerta, Container, Divisor, FormFooter, Interno, Linha, Titulo,
} from '../../styles/base';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import { setAuthToken, getTotem } from '../../api/apiFactory';
import { Orientacoes } from './FormularioSicEstilo';
import {
  ColunaForm, LinhaForm, LinhaFormGap, Pergunta,
} from '../FormControl/FormControlEstilo';

const defaultValues = {
  Pergunta: '',
  IdSecretaria: '',
  IdSecretariaAssunto: '',
  IdUnidade: '',
  IdOpcaoUrgencia: '',
  DadosSigilosos: 'N',
  Urgente: 'N',
};

const FormularioSic = () => {
  const [values, setValues] = useState(defaultValues);
  const [listaAssuntos, setListaAssuntos] = useState(null);
  const [listaUnidades, setListaUnidades] = useState(null);
  const [orientacoes, setOrientacoes] = useState(null);
  const [listaUrgenteJustificativas, setListaUrgenteJustificativas] = useState(null);
  const [arquivos, setArquivos] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const dadosLogin = useSelector(selectLogin);
  const dadosSecretaria = useSelector(selectSecretaria);
  const dispatch = useDispatch();
  const alert = useAlert();
  const history = useHistory();
  const dadosCidade = useSelector(selectCidade);

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    if (id) {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  const validate = () => {
    if (!values.IdSecretariaAssunto) {
      alert.error('Verifique o campo assunto.', { timeout: 5000 });
      return false;
    }
    if (!values.Pergunta) {
      alert.error('Verifique o campo pedido de informação.', { timeout: 5000 });
      return false;
    }
    if (values.Urgente === 'S' && !values.IdOpcaoUrgencia) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (values.Urgente === 'S' && arquivos.length === 0) {
      alert.error('Ao solicitar prioridade na tramitação, deverá, obrigatoriamente, anexar prova de sua condição.', { timeout: 5000 });
      return false;
    }
    return true;
  };

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  useEffect(() => {
    setValues({
      ...values,
      IdSecretaria: dadosSecretaria && dadosSecretaria.data && dadosSecretaria.data.idSecretaria,
    });

    checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);

    Promise.all([
      fetchSecretarias2(),
      fetchUrgenteJustificativas(),
    ]).then(([dadosSecretarias, dadosUrgenteJustificativas]) => {
      setListaUrgenteJustificativas(dadosUrgenteJustificativas);

      const secretaria = dadosSecretarias && dadosSecretarias.find(
        ({ Id }) => Id === dadosSecretaria.data.idSecretaria,
      );

      if (!secretaria) {
        history.push('/');
        dispatch(desfazerConexao());
        dispatch(desfazerSecretaria());
      }

      const assuntos = secretaria && secretaria.Assuntos;
      const unidades = secretaria && secretaria.Unidades;

      setListaAssuntos(assuntos);
      setListaUnidades(unidades);
    });

    // Antes, apenas a requisição fetchSecretarias() era feita. Então era mais prático fazer utilizando apenas o then(). Ja agora, tem também a fetchUrgenteJustificativas().
    // Dito isso, agora é mais interessante agrupar as requisições em uma mesma Promise, conforme está sendo feito acima, o que possibilita um único then().
    // A rquisição de fetchSecretarias() foi apenas movida para acima. Mas a sua lógica se mantém a mesma;

    // fetchSecretarias().then((dadosSecretarias) => {
    //   const secretaria = dadosSecretarias && dadosSecretarias.find(
    //     ({ Id }) => Id === dadosSecretaria.data.idSecretaria,
    //   );

    //   const assuntos = secretaria && secretaria.Assuntos;

    //   setListaAssuntos(assuntos);
    // });
  }, [dadosSecretaria, dadosLogin]);

  const removerArquivo = ({ path }) => {
    setArquivos(arquivos.filter((arq) => arq.path !== path));
  };

  const adicionarArquivo = async (arquivo) => {
    if (arquivo.length + arquivos.length > 10) {
      return (
        alert.error('Limite de 10 arquivos permitido.', { timeout: 5000 })
      );
    }

    const validarRepetidos = () => {
      const arquivoExiste = arquivo.map(({ path: arq }) => arquivos.length && arquivos.find(({ path }) => arq === path))[0];
      const caminhoRepetido = arquivoExiste && arquivo.map(({ path: arq }) => arquivos.length && arquivos.find(({ path }) => arq === path))[0].path;

      return caminhoRepetido;
    };

    if (validarRepetidos()) {
      return (
        alert.error('Você já subiu um arquivo com esse nome.', { timeout: 5000 })
      );
    }

    return (
      setArquivos(arquivos.concat(arquivo.map((file) => Object.assign(file, {
        preview: URL.createObjectURL(file),
      }))))
    );
  };

  const ExibirErroTamanhoArquivo = (arquivo) => {
    // Você deve estar se perguntando: "Por que não fez essa validação também no método de adição de arquivos, assim como as outras validações foram feitas (de quantidade de arquivos e nomes repetidos)?"
    // Resposta: No FormControl, tem um atributo "maxSize" com valor limite para 200MB, e quanto o limite atinge, esse atributo bloqueia a inserção do arquivo e nem sequer ativa o método de adição que criei, logo eu não consigo personalizar uma mensagem de erro.
    // Dito isso, eu adicionei um atributo "onDropRejected" que é ativado justamente quando algum arquivo da erro, e daí nele eu personalizo uma função para exibir a mensagem de erro para o tamanho do arquivo.
    // Temos o atributo "onDrop", que é acionado sempre ao soltar os arquivos, e ele está bloqueando a chamada do adicionarArquivos devido ao erro soltado no maxSize do formControl, e temos agora também o "onDropRejected", que será chamado justamente se um erro desse tipo for liberado (erros tratados automaticamente pelo componente, como o tamanho do arquivo);
    // No método adicionarArquivos a gente consegue controlar erros os quais não são conhecidos pelo compomente de drop, no caso são "erros" personalizados por nós, ou seja, regras, tal como o limite de 10 arquivos, e de não pode adicionar um arquivo repetido. Já um erro de tamanho de arquivo isso é controlado nativamente pelo atributo maxSize do componente dropzone;
    // Resumindo: Aquilo que não for um erro de fato, no caso for uma regra NOSSA, como limite de arquivos, tratamentos de nome do arquivo etc, a gente consegue tratar no método de adição, que é acionado pelo atributo "onDrop". Já erros nativos, como o tamanho limite imposto aos arquivos, a gente precisa adicionar o "onDropRejected" que justamente receberá em formato de array cada um dos arquivos que deram erro apenas.

    // Limite: 200MB. Isso foi definido no arquivo "FormControl", aqui eu estou apenas adicionando uma lógica para exibir uma mensagem de retorno pois o Dropzone não mostra erro algum.
    // OBS: Se eu inserir mais de um arquivo por vez e algum deles tiver menos de 200MB, este será adicionado corretamente, mas os outros não. Caso peçam para que não adicione NENHUM, eu preciso passar essa lógica também para o método "adicionar" acima.
    const MAX_FILE_SIZE = 200000000;

    const arquivosGrandes = arquivo.filter((item) => item.file.size > MAX_FILE_SIZE);

    if (arquivosGrandes.length === 1) {
      return alert.error('O tamanho máximo permitido para um arquivo é de 200MB.', { timeout: 5000 });
    }

    if (arquivosGrandes.length > 0) {
      const nomesArquivosGrandes = arquivosGrandes.map((item) => item.file.name).join(', ');
      return alert.error(`Os seguintes arquivos ultrapassam o tamanho máximo permitido de 200MB: ${nomesArquivosGrandes}.`, { timeout: 10000 });
    }

    return alert.error('Ocorreu um erro durante a inserção de arquivo. Confira o tipo dos arquivos a serem inseridos e tente novamente.', { timeout: 5000 });
  };

  const retiraAcentos = (str) => {
    const comAcento = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ';
    const semAcento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr';
    let novaStr = '';
    for (let i = 0; i < str.length; i += 1) {
      let troca = false;
      for (let a = 0; a < comAcento.length; a += 1) {
        if (str.substr(i, 1) === comAcento.substr(a, 1)) {
          novaStr += semAcento.substr(a, 1);
          troca = true;
          break;
        }
      }
      if (troca === false) {
        novaStr += str.substr(i, 1);
      }
    }
    return novaStr;
  };

  const enviarSic = async (event) => {
    event.preventDefault();
    setCarregando(true);

    if (!validate()) {
      setCarregando(false);
      return;
    }

    const validarConfiguracoesAnonimas = await fetchConfiguracoes();

    if (validarConfiguracoesAnonimas && validarConfiguracoesAnonimas.OcultarAnonimoSic === 'N' && dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'anonimo') {
      alert.error('As configurações da cidade foram alteradas e agora não é mais permitido enviar um pedido de informação de forma anônima. Por favor, tente fazer o login.', { timeout: 10000 });
      setCarregando(false);
      return;
    }

    const resposta = await postSic({
      anexos: arquivos,
      ...values,
    });

    if (resposta instanceof Array) {
      alert.error('Não foi possível subir os anexos.', { timeout: 5000 });
      setCarregando(false);
      return;
    }

    if (resposta.Error) {
      alert.error(resposta.Error, { timeout: 5000 });
      setCarregando(false);
      return;
    }

    setValues(defaultValues);
    setArquivos([]);

    setCarregando(false);

    // Mensagem de sucesso, exibindo o protocolo, que some depois de 20000ms. Está comentado pois agora é necessário deixar o protocolo sendo exibido.
    // alert.info(resposta.Message, { timeout: 20000 });

    alert.info(resposta.Message);

    setValues(defaultValues);

    dispatch(desfazerSecretaria());
    if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  if (!listaAssuntos || !listaUrgenteJustificativas) {
    return (
      <Carregar />
    );
  }

  if (listaAssuntos.Error || listaUrgenteJustificativas.Error) {
    history.push('/');
    dispatch(desfazerConexao());
    dispatch(desfazerCidade());
    dispatch(desfazerSecretaria());
    return (
      <Carregar />
    );
  }

  return (
    <>
      <Container>
        {dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade === 'São Sebastião' ? (
          <Titulo>SIC - Informação ao Cidadão</Titulo>
        ) : (
          <Titulo>Pedido de Informação (e-SIC)</Titulo>
        )}

        <Interno>
          <Alerta style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <strong style={{ fontSize: '0.9em' }}>* Os campos com asterisco são obrigatórios.</strong>
          </Alerta>

          <Divisor style={{ marginBottom: 6, paddingBottom: 6 }} />

          <form>
            <FormControl
              type="secretaria"
              dadosSecretaria={dadosSecretaria}
              onClick={() => dispatch(desfazerSecretaria())}
            />

            <LinhaForm>
              <FormControl
                idCampo="selectAssunto"
                value={values.IdSecretariaAssunto}
                label="Assunto:"
                options={listaAssuntos}
                onChange={({ target }) => {
                  setOrientacoes(null);
                  setVal('IdSecretariaAssunto', target.value);
                  if (target.value) {
                    fetchOrientacoes(target.value).then((data) => setOrientacoes(data));
                  }
                }}
                required
                type="select"
              />

              {(listaUnidades && listaUnidades.length > 0) && (
                <FormControl
                  idCampo="selectUnidade"
                  value={values.IdUnidade}
                  label="Unidade:"
                  options={listaUnidades}
                  onChange={({ target }) => setVal('IdUnidade', target.value)}
                  type="select"
                  direita
                />
              )}
            </LinhaForm>

            {(orientacoes && orientacoes[0].Campo && orientacoes[0].Campo !== 'NULL') && (
              <>
                <Orientacoes>
                  <b>Orientações ao Solicitante:</b>

                  <Divisor style={{ marginBottom: 2, paddingBottom: 2 }} />

                  <span>{orientacoes[0].Campo}</span>
                </Orientacoes>

                <Divisor size="ultraPequeno" />
              </>
            )}

            <FormControl
              label="Pedido de informação:"
              value={values.Pergunta}
              onChange={({ target }) => setVal('Pergunta', target.value)}
              required
              tamanhoFlex={3}
              type="textarea"
            />

            {(dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade && !dadosCidade.data.nomeCidade.toLowerCase().includes('cincatarina')) && (
              <ColunaForm borda style={{ marginBottom: 12 }}>
                <LinhaFormGap style={{ justifyContent: 'space-between' }}>
                  <Pergunta>
                    Solicitante deseja prioridade na tramitação? Conforme
                    {' '}
                    <a href="https://www.planalto.gov.br/ccivil_03/LEIS/L9784.htm#art69a" target="_blank" rel="noreferrer" title="Lei Federal nº 9.784/1999">Lei Federal nº 9.784/1999</a>
                    {dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade === 'Juiz de Fora' && (
                      <>
                        {' '}
                        e
                        {' '}
                        <a href="https://jflegis.pjf.mg.gov.br/norma.php?chave=0000051079" target="_blank" rel="noreferrer" title="Lei Municipal nº 14.511/2022">Lei Municipal nº 14.511/2022</a>
                      </>
                    )}
                  </Pergunta>
                  <Linha style={{ gap: 30, justifyContent: 'flex-end' }}>
                    <label htmlFor="radioSimUrgente">
                      <input type="radio" id="radioSimUrgente" value="S" name="Urgente" onChange={({ target }) => setVal('Urgente', target.value)} />
                      {' '}
                      Sim
                    </label>
                    {' '}
                    <label htmlFor="radioNaoUrgente">
                      <input type="radio" id="radioNaoUrgente" value="N" name="Urgente" onChange={({ target }) => setValues({ ...values, Urgente: target.value, IdOpcaoUrgencia: '' })} defaultChecked />
                      {' '}
                      Não
                    </label>
                  </Linha>
                </LinhaFormGap>

                {values.Urgente === 'S' && (
                  <>
                    <p>
                      <b>ATENÇÃO:</b>
                      {' '}
                      A pessoa interessada na obtenção do benefício, independente da opção selecionada, deverá, obrigatoriamente, anexar prova de sua condição para ser validada. Caso não apresente documento comprobatório o pedido de informação seguirá tramitação normal.
                    </p>

                    <FormControl
                      idCampo="selectUrgenteJustificativa"
                      value={values.IdOpcaoUrgencia}
                      label="Escolha uma das opções:"
                      options={listaUrgenteJustificativas}
                      onChange={({ target }) => setVal('IdOpcaoUrgencia', target.value)}
                      required
                      type="select"
                    />
                  </>
                )}
              </ColunaForm>
            )}

            {/* Para exibir esse campo, precisa estar logado (primeira condição) E a propriedade OcultarDadosSigilososSic precisa ser igual a 'S' (segunda condição) */}
            {(dadosLogin && dadosLogin.data && dadosLogin.data.anonimo && dadosLogin.data.anonimo === 'naoanonimo')
            && (dadosCidade
              && dadosCidade.configuracoes
              && dadosCidade.configuracoes.OcultarDadosSigilososSic
              && dadosCidade.configuracoes.OcultarDadosSigilososSic === 'S')
              ? (
                <FormControl
                  label="Deseja manter seus dados sigilosos?"
                  nameRadio="DadosSigilosos"
                  idRadio="radioSim"
                  valueRadio="S"
                  labelRadio="Sim"
                  changeRadio={({ target }) => setVal('DadosSigilosos', target.value)}
                  idRadio2="radioNao"
                  valueRadio2="N"
                  labelRadio2="Não"
                  changeRadio2={({ target }) => setVal('DadosSigilosos', target.value)}
                  checkedRadio2
                  type="radio"
                />
              ) : (null)}

            {(getTotem() !== 'true') && (
            <FormControl
              type="arquivo"
              dadosArquivos={arquivos}
              onDrop={adicionarArquivo}
              onDropRejected={ExibirErroTamanhoArquivo}
              onRemove={removerArquivo}
              required={values.Urgente === 'S'}
            />
            )}

            <FormFooter>
              {carregando !== true
                ? (
                  <Botao
                    label="Enviar"
                    type="submit"
                    onClick={enviarSic}
                  />
                )
                : (
                  <Carregar />
                )}
            </FormFooter>
          </form>
        </Interno>
      </Container>
    </>
  );
};

export default FormularioSic;
